import { createApp, type App } from 'vue';
import AntDesignVue from 'ant-design-vue';
import ResidencyBecomeDocumentsUpload from './residency-become-documents-upload.vue';

const MOUNT_ID = 'residency-become-documents-upload';

let documentsApp: App<Element> | null = null;
let documentsInstance: InstanceType<typeof ResidencyBecomeDocumentsUpload> | null = null;

export function initResidencyBecomeDocumentsUpload(root?: ParentNode): void {
  const mountEl = root
    ? (root.querySelector<HTMLElement>(`#${MOUNT_ID}`) ?? document.getElementById(MOUNT_ID))
    : document.getElementById(MOUNT_ID);

  if (!mountEl) {
    return;
  }

  if (documentsApp) {
    documentsApp.unmount();
    mountEl.innerHTML = '';
  }

  const app = createApp(ResidencyBecomeDocumentsUpload);
  app.use(AntDesignVue);
  documentsInstance = app.mount(mountEl) as InstanceType<typeof ResidencyBecomeDocumentsUpload>;
  documentsApp = app;
}

export function getResidencyBecomeDocumentsUpload(): InstanceType<
  typeof ResidencyBecomeDocumentsUpload
> | null {
  return documentsInstance;
}
